import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles({
  form: {
    width: "auto",
    marginTop: "20px",
    marginRight: "15px",
    marginLeft: "15px",
  },
  formControl: {
    padding: "8px",
    maxHeight: "48px",
    maxWidth: "331px",
  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
  },
  formField: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    height: "35px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: "#e0e0e0",
    },
    // "& ~ p": {
    //   marginTop: "2px",
    // },
  },
  phoneField: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    border: "0",
    borderRadius: "8px",
    height: "35px",
    fontSize: "14px",
  },

  title: {
    marginBottom: "30px",
  },
});

export const styleSearch = makeStyles({
  table: {
    minWidth: 500,
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#666666",
    "&:hover": { color: "white", background: "#099F9F" },
  },
  buttonClear: {
    color: "#666666",
    border: "solid 1px",
    background: "#ffffff",
    "&:hover": { color: "#099F9F", background: "#ffffff" },
  },
  form: {
    paddingTop: "40px",
  },
  card: {
    marginTop: "-45px",
    marginLeft: "8px",
    maxWidth: "699.5px",
    maxHeight: "233px",
  },
  formControl: {
    padding: "8px",
    maxHeight: "48px",
    maxWidth: "331px",
  },
  select: {
    paddingTop: "10.5px",
    paddingBottom: "10.5px",
  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
  },
});
